import React, { ChangeEvent } from 'react';
import { camelCase, omitBy } from 'lodash';
import { FormProps } from './types';

interface CheckboxesProps extends Omit<FormProps, 'value'> {
  value: Record<string, any>;
}

function Checkboxes({
  name, question, value, onChange,
}: CheckboxesProps, ref) {
  if (question.type !== 'checkboxes') return null;

  const handleMultiCheckbox = (evt: ChangeEvent<HTMLInputElement>) => {
    const current = { ...value };
    current[evt.target.value] = evt.target.checked;
    const filtered = omitBy(current, (v) => (!v));
    onChange(Object.keys(filtered).length > 0 ? filtered : undefined);
  };

  return (
    <>
      <div className="dynamic-form-label">{question.label}</div>
      <div>
        {
          question.values.map((v) => (
            <div key={`${name}.${camelCase(v)}`} className="dynamic-checkbox">
              <input
                type="checkbox"
                id={`${name}.${camelCase(v)}`}
                name={name}
                value={v}
                onChange={handleMultiCheckbox}
                checked={(value && value[v]) || false}
                ref={ref}
              />
              <label htmlFor={`${name}.${camelCase(v)}`}>{v}</label>
            </div>
          ))
        }
      </div>
    </>
  );
}

export default React.forwardRef(Checkboxes);
